import './SmartAccountLoader.css';

interface SmartAccountLoaderProps {
  message?: string;
  fullScreen?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export default function SmartAccountLoader({ 
  message, 
  fullScreen = false,
  size = 'medium'
}: SmartAccountLoaderProps) {
  const sizeClasses = {
    small: 'loader-small',
    medium: 'loader-medium',
    large: 'loader-large'
  };

  return (
    <div className={`smart-account-loader ${fullScreen ? 'full-screen' : ''} ${sizeClasses[size]}`}>
      <div className="loader-content">
        <div className="spinner-wrapper">
          <div className="main-spinner"></div>
          <div className="inner-spinner"></div>
          {size !== 'small' && <div className="center-dot"></div>}
        </div>
        
        {(message || size !== 'small') && (
          <div className="loader-text-container">
            {size !== 'small' && (
              <div className="brand-text">
                <span className="smart">Smart</span>
                <span className="account">Account</span>
              </div>
            )}
            {message && <p className="loader-message">{message}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
